export default __webpack_public_path__ + "static/media/3.914d9781.jpg";